import { render, staticRenderFns } from "./TierIcon.vue?vue&type=template&id=9ecd2002&scoped=true&"
import script from "./TierIcon.vue?vue&type=script&lang=js&"
export * from "./TierIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecd2002",
  null
  
)

export default component.exports